import { alpha } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";

export const getDialogPaperSx = (theme: Theme) => ({
  borderRadius: 4,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.background.paper, theme.palette.mode === "dark" ? 0.98 : 1),
  backgroundImage: "none",
  boxShadow: theme.shadows[12],
  overflow: "hidden",
});

export const dialogShellSx = {
  display: "flex",
  flexDirection: "column",
  maxHeight: "min(88vh, 940px)",
  backgroundColor: "background.paper",
} as const;

export const getDialogHeaderSx = (theme: Theme) => ({
  position: "relative",
  px: { xs: 2, md: 3 },
  py: { xs: 2, md: 2.5 },
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
});

export const dialogTitleSx = {
  fontSize: { xs: 24, md: 32 },
  fontWeight: 700,
  lineHeight: 1.1,
} as const;

export const dialogBodySx = {
  px: { xs: 2, md: 3 },
  py: { xs: 2, md: 2.5 },
  overflowY: "auto",
} as const;

export const getDialogFooterSx = (theme: Theme) => ({
  position: "sticky",
  bottom: 0,
  px: { xs: 2, md: 3 },
  py: 2,
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
});

export const dialogActionsSx = {
  justifyContent: "flex-end",
  gap: 1,
  px: 0,
  py: 0,
} as const;

export const getDialogCloseButtonSx = (theme: Theme) => ({
  position: "absolute",
  right: 8,
  top: 8,
  color: theme.palette.grey[500],
});
